import { Button, Kind, Size } from "@usitsdasdesign/dds-react"
import Text from "atoms/Text"
import Image from "next/image"


function DataRow({ DataRow = [], onClick, Isbutton = false, Islinebutton = false, Buttonlabel, isSubservice = 'false' }) {
    return (
        <>
            {
                DataRow.map((row, i) => (
                    <div className='p-1 border border-grey-600 mb-1 mt-1 flex items-center relative' key={i}>
                        <Image src={row.userpic} height="40" width="40" alt="user"/>
                        <div className=''>
                            <div className='flex ml-2'>
                                <Text variant='bodySemibold' color="text-black">{row.name}&nbsp;</Text>
                                <Text variant='body' color="text-gray-600">(ID: {row.empID})</Text>
                            </div>
                            <div className='flex flex-wrap md:w-[484px] ml-2 pr-28'>
                                <Text variant='body' color="text-gray-1100">{row.designation} |</Text>
                                <Text variant='body' color="text-gray-1100"> {row.position} | </Text>
                                <Text variant='body' color="text-gray-1100"> {row.category}  | </Text>
                                <Text variant='body' color="text-gray-1100"> {row.Subcategory} </Text>
                            </div>
                            {
                                isSubservice && (
                                    <div className='flex flex-wrap md:w-[484px] ml-2 pr-28'>
                                        <Text variant='body' color="text-gray-1100">Sub service (L3) :{row.Subservice} |</Text>
                                    </div>
                                )
                            }
                        </div>
                        <div className='absolute right-2'>
                            {
                                Isbutton && (
                                    <Button label={Buttonlabel} size={Size.m} kind={Kind.primaryLoud} onClick={onClick} />
                                )
                            }
                            {
                                Islinebutton && (
                                    <Button label='Change' size={Size.m} kind={Kind.silent} onClick={onClick} />
                                )
                            }

                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default DataRow